import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import {
  Button,
  UncontrolledTooltip,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import { addFlashMessage } from '../../helpers/FlashMessages';

const ShareModalLinkCopy = ({ linkUrl, text, showTooltip }) => {
  const [linkCopied, setLinkCopied] = useState(false);

  const intl = useIntl();

  useEffect(() => {
    setLinkCopied(false);
  }, [linkUrl]);

  const copyLink = () => {
    setLinkCopied(true);
    addFlashMessage({
      type: 'success',
      text: intl.formatMessage({ defaultMessage: 'The link was copied to your clipboard!' }),
      duration: 5000,
    });
  };

  if (!linkUrl) {
    return null;
  }

  return (
    <div className="share-item-actions share-link-copy-wrapper">
      <CopyToClipboard
        text={linkUrl}
        options={{
          format: 'text/plain',
        }}
        onCopy={copyLink}
      >
        <Button tag="span" color="link" id="linkSharingShow" className={classnames('share-link-copy', { copied: linkCopied })}>
          <i className="fas fa-clone" />
          {text}
        </Button>
      </CopyToClipboard>
      {showTooltip && (
        <UncontrolledTooltip placement="bottom" target="linkSharingShow">
          {linkCopied ?
            intl.formatMessage({ defaultMessage: 'Link was copied to your clipboard' }) :
            intl.formatMessage({ defaultMessage: 'Copy link' })}
        </UncontrolledTooltip>
      )}
    </div>
  );
};

ShareModalLinkCopy.propTypes = {
  linkUrl: PropTypes.string.isRequired,
  text: PropTypes.string,
  showTooltip: PropTypes.bool,
};

ShareModalLinkCopy.defaultProps = {
  text: '',
  showTooltip: true,
};

export default ShareModalLinkCopy;
